import styled from 'styled-components';
export const ContentContainer = styled.div.withConfig({
  displayName: "ActivitySubmenustyle__ContentContainer",
  componentId: "sc-qjcedp-0"
})(["", " a{", "}"], {
  "borderRadius": "0.5rem",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "paddingBottom": "0.75rem",
  "paddingTop": "1rem"
}, {
  "display": "flex",
  "alignItems": "center",
  "--tw-text-opacity": "1",
  "color": "rgb(43 43 43 / var(--tw-text-opacity, 1))"
});
export const ActiveLine = styled.div.withConfig({
  displayName: "ActivitySubmenustyle__ActiveLine",
  componentId: "sc-qjcedp-1"
})(["", " visibility:", ";"], {
  "marginTop": "-0.25rem",
  "marginRight": "3px",
  "height": "30px",
  "width": "5px",
  "borderRadius": "100px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(206 14 45 / var(--tw-bg-opacity, 1))"
}, ({
  $isActive
}) => $isActive ? 'visible' : 'hidden');
export const ContentWrapper = styled.div.withConfig({
  displayName: "ActivitySubmenustyle__ContentWrapper",
  componentId: "sc-qjcedp-2"
})(["", " &:hover{", " background-color:", ";color:", ";}"], {
  "marginBottom": "0.25rem",
  "width": "100%",
  "paddingLeft": "0.75rem",
  "paddingRight": "0.75rem",
  "paddingTop": "0.25rem",
  "paddingBottom": "0.25rem",
  "fontSize": "1.5rem",
  "lineHeight": "2rem",
  "fontWeight": "700"
}, {
  "borderRadius": "0.25rem"
}, "#FAE7EA", "#CE0E2D");